import { combineReducers } from 'redux';
import { results, response, enrollerDetailsResponse } from './edeSearchResults';

export default combineReducers({
    results,
    response,
    enrollerDetailsResponse
});